import { createContext, useState } from 'react';
import { PropTypes } from 'prop-types';
import { whatPeopleSayData } from '../../pages/home/sections/quote/data';

export const QuoteContext = createContext({});

const QuoteContextProvider = ({ children }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const next = () => {
    setActiveSlide((prev) => {
      if (prev === whatPeopleSayData.length - 1) {
        return 0;
      } else {
        return prev + 1;
      }
    });
  };

  const prev = () => {
    setActiveSlide((prev) => {
      if (prev === 0) {
        return whatPeopleSayData.length - 1;
      } else {
        return prev - 1;
      }
    });
  };
  return (
    <QuoteContext.Provider value={{ activeSlide, prev, next, setActiveSlide }}>
      {children}
    </QuoteContext.Provider>
  );
};

QuoteContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default QuoteContextProvider;
